"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_urls_1 = require("@tableau/shared-urls");
var React = require("react");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
function createDefaultSiteUrls() {
    var siteUrls = new shared_urls_1.SiteUrls({ siteUrlName: '' });
    for (var key in siteUrls) {
        if (typeof siteUrls[key] === 'function') {
            siteUrls[key] = TypescriptHelpers_1.createErrorFunction("Function of default SiteUrls context called: " + key);
        }
    }
    return siteUrls;
}
exports.createDefaultSiteUrls = createDefaultSiteUrls;
var defaultSiteUrls = createDefaultSiteUrls();
exports.SiteUrlsContext = React.createContext(defaultSiteUrls);
//# sourceMappingURL=SiteUrlsContext.js.map